import { useState } from "react";
import { getUserLogs } from "../../../services/apis/monitorApis";
import { toastError } from "../../../utils/toastUtils";

const useUserLogs = () => {
  const [logs, setLogs] = useState([]);
  const [pageTrack, setPageTrack] = useState({
    currPage: undefined,
    totalPages: undefined
  });

  const logTypeOptions = [
    { value: "login", label: "Login" },
    { value: "logout", label: "Logout" }
  ];

  const fetchLogs = async (search, page, limit, filterParams = {}) => {
    try {
      const filters = {
        search,
        page,
        limit,
        ...filterParams
      };

      const response = await getUserLogs(filters);
      const data = response?.data;

      setLogs(data?.logs || []);
      setPageTrack({
        currPage: data?.page,
        totalPages: data?.total_pages
      });
    } catch (error) {
      toastError(error?.response?.data?.message || "Failed to fetch user logs");
    }
  };

  return {
    logs,
    pageTrack,
    fetchLogs,
    setLogs,
    setPageTrack,
    logTypeOptions
  };
};

export default useUserLogs;
